import { ArticleType } from "lib/types/article-type";
import AddArticleComponent from "../quill-editor";

export default function CreateNewNewsPage() {
    return (
        <AddArticleComponent type={ArticleType.article} />
    )
}